export default __webpack_public_path__ + "static/media/check-circle-icon.dda399ce.svg";